import { themeT } from '@/utils/themeText';
import type { ListItem } from '../../Shipments/ControlTower/types';
import theme from '@/assets/theme';

export type FilterConfigItem = {
  id: number;
  key: string;
  label: string;
  hasDividerBelow?: boolean;
};

export type FilterConfigGroup = {
  group: string;
  items: FilterConfigItem[];
};

export type FilterConfigShape = {
  topLevelFilters: FilterConfigItem[];
  groupedFilters: FilterConfigGroup[];
};

/**
 * Filter keys that are only meaningful in Per SKU view.
 * These must be hidden from the filter dropdown AND stripped from applied
 * filter state whenever the user switches to Per Device view.
 */
export const PER_DEVICE_HIDDEN_FILTER_KEYS = new Set([
  'record_type',
  'stock_vs_required_state',
  'stock_planning_state',
  'structure',
  'notification_setup',
]);

export const inventoryFiltersConfig: FilterConfigShape = {
  topLevelFilters: [],
  groupedFilters: [
    {
      group: 'Filter by',
      items: [
        { id: 101, key: 'locations', label: 'Location' },
        {
          id: 102,
          key: 'team',
          label: `${themeT('team', theme.themeType)}`,
          hasDividerBelow: true,
        },

        { id: 103, key: 'record_type', label: 'Record type' },
        {
          id: 104,
          key: 'stock_vs_required_state',
          label: 'Stock vs required state',
        },
        {
          id: 105,
          key: 'stock_planning_state',
          label: 'Stock planning state',
        },

        {
          id: 106,
          key: 'structure',
          label: 'Structure',
        },

        {
          id: 107,
          key: 'notification_setup',
          label: 'Notification setup',
          hasDividerBelow: true,
        },
        { id: 108, key: 'last_updated', label: 'Last updated' },
      ],
    },
  ],
};
export const inventoryFilterLookups: {
  recordTypes: ListItem[];
  stockVsRequiredStates: ListItem[];
  stockPlanningStates: ListItem[];
  notificationSetupOptions: ListItem[];
  structures: ListItem[];
} = {
  recordTypes: [
    { id: 'item', name: 'Item', title: 'Item' },
    { id: 'kit', name: 'Kit', title: 'Kit' },
  ],
  stockVsRequiredStates: [
    { id: 'low', name: 'Low', title: 'Low' },
    { id: 'high', name: 'High', title: 'High' },
    {
      id: 'no_reorder_target',
      name: 'No reorder target',
      title: 'No reorder target',
    },
  ],
  stockPlanningStates: [
    {
      id: 'under_total_required',
      name: 'Under total required',
      title: 'Under total required',
    },
    {
      id: 'at_or_above_total_required',
      name: 'At or above total required',
      title: 'At or above total required',
    },
    {
      id: 'no_total_required',
      name: 'No total required',
      title: 'No total required',
    },
  ],
  notificationSetupOptions: [
    {
      id: 'notification_configured',
      name: 'Notification configured',
      title: 'Notification configured',
    },
    {
      id: 'no_notification_configured',
      name: 'No notification configured',
      title: 'No notification configured',
    },
  ],
  structures: [
    {
      id: 'has_sub_items',
      name: 'Has sub-items',
      title: 'Has sub-items',
    },
    {
      id: 'no_sub_items',
      name: 'No sub-items',
      title: 'No sub-items',
    },
  ],
};
